import { useSyncExternalStore } from 'react'

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const mql = window.matchMedia(query)
      mql.addEventListener('change', onChange)
      return () => mql.removeEventListener('change', onChange)
    },
    () => window.matchMedia(query).matches,
    () => false,
  )
}

/** True below Tailwind's `md` breakpoint — the app's phone/tablet-portrait cutoff. */
export function useIsMobile(): boolean {
  return useMediaQuery('(max-width: 767px)')
}
